















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { resumeService } from "./resumeService";

@Component
export default class ResumeHeader extends Vue {
    get currentTitle() {
        const [currentCompany] = resumeService.companies;
        return currentCompany.roles
            ? currentCompany.roles[0].role
            : currentCompany.name;
    }

    get githubImage() {
        return require("../../assets/resume/github.svg");
    }

    get linkedInImage() {
        return require("../../assets/resume/linkedin.png");
    }

    get emailImage() {
        return require("../../assets/resume/email.png");
    }
}
